module.exports = __webpack_public_path__ + "media/images/responsive/lp/clean/faq_hairmakeup_04_sp-e77bdc332b55d43402afa411c8b2349b.png";